export enum View {
	OVERVIEW = 'overview',
	RECENT = 'recent',
	STARRED = 'starred',
	DRAFTS = 'drafts',
	TASKS = 'tasks',
}

export const SUPPORTED_ROUTES: View[] = [View.RECENT, View.STARRED, View.DRAFTS, View.TASKS];
